<template>
    <div>
        <div class="mt-4 mb-2 font-weight-bold">Tryout</div>

        <v-progress-circular
            v-if="isLoading"
            color="primary"
            indeterminate
        ></v-progress-circular>

        <v-simple-table v-else>
            <thead>
                <tr>
                    <th>Nama</th>
                    <th>Status</th>
                    <th>Mulai</th>
                    <th>Selesai</th>
                    <th>Nilai</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(history, idx) in histories"
                    :key="idx"
                >
                    <td>{{ history.tryout.title }}</td>
                    <td>{{ history.stateString }}</td>
                    <td>{{ history.startedAt }}</td>
                    <td>{{ history.finishedAt }}</td>
                    <td>{{ history.grade }}</td>
                    <td>
                        <v-btn color="red" icon>
                            <v-icon @click="deleteTryout(history)">mdi-delete</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>

        <user-tryout-delete-dialog
            @delete="updateUserTryoutHistories"
            ref="deleteDialog"
        ></user-tryout-delete-dialog>
    </div>
</template>

<script>
import moment from '@/plugins/moment'
import UserTryoutDeleteDialog from './UserTryoutDeleteDialog.vue'

const STATES = {
    started: 'Dimulai',
    ongoing: 'Mengerjakan',
    paused: 'Dijeda',
    finished: 'Selesai'
}

export default {
    props: {
        enrollment: {
            type: Object,
            required: true
        },

        user: {
            type: Object,
            required: true
        }
    },

    components: {
        UserTryoutDeleteDialog,
    },

    data: () => ({
        histories: null,
        isLoading: true,
    }),

    methods: {
        deleteTryout(history) {
            this.$refs.deleteDialog.show(this.user, history, this.enrollment)
        },

        async updateUserTryoutHistories() {
            this.isLoading = true

            const response = await this.$apiv2.get(`period/${this.enrollment.period.id}/user/${this.user.id}/tryout-history`)

            this.histories = response.data.tryoutHistories
                .map(history => ({
                    ...history,
                    stateString: STATES[history.state],
                    startedAt: moment(history.startedAt).formatShortDayAndTime(),
                    finishedAt: history.finishedAt ? moment(history.finishedAt).formatShortDayAndTime() : null
                }))

            this.isLoading = false
        }
    },

    created() {
        this.updateUserTryoutHistories()
    }
}
</script>
